const highlightedReviewNoteGetter = ({ note, selectedKeywordIds = [], styles = {} }) => {
  // if any keyword tags are selected, highlight that keywords only
  // if none of the keyword tags are selected, highlight all primary keywords
  const matchedIds =
    selectedKeywordIds.length > 0
      ? selectedKeywordIds
      : note?.primary_keywords?.map((keyword) => keyword.id.toString());

  const flavorWordClass = styles[`highlightReview-${note.group}`];

  return (review) => {
    const isTaggedReview =
      (review?.flavor_word_matches?.length || 0) > 0 &&
      flavorWordClass &&
      (matchedIds?.length || 0) > 0;

    if (!isTaggedReview) {
      return review.tagged_note;
    }

    const flavorRegex = new RegExp(
      review.flavor_word_matches.reduce((memo, flavorMatch) => {
        if (matchedIds.includes(flavorMatch.id.toString())) {
          if (memo.length > 0) {
            memo += '|';
          }
          memo += flavorMatch.match;
        }
        return memo;
      }, ''),
      'gi'
    );

    return review.tagged_note.replace(
      flavorRegex,
      (match) => `<span class="${flavorWordClass}">${match}</span>`
    );
  };
};

export default highlightedReviewNoteGetter;
